import { jsx } from "react/jsx-runtime";
import { createElement } from "react";
import { Chip, Typography } from "@mui/material";
import { useCallback } from "react";
function useRenderTags(props, getOptionLabel, getLimitTagsText, maxSelectedItemsToShow, maxSelectedItemsToShowOnFocus) {
  const {
    multiSelectState: { props: componentProps }
  } = props;
  const defaultRenderTags = useCallback(
    (selectedOptions, getTagProps, ownerState) => {
      const limit = ownerState.focused ? maxSelectedItemsToShowOnFocus : maxSelectedItemsToShow;
      const length = limit > 0 ? limit : selectedOptions.length;
      const output = selectedOptions.slice(0, length).map((option, index) => /* @__PURE__ */ createElement(Chip, { label: getOptionLabel(option), ...getTagProps({ index }), key: `${index}` }));
      const more = selectedOptions.length - limit;
      if (more > 0) {
        output.push(/* @__PURE__ */ jsx("span", { children: getLimitTagsText(more) }, output.length));
      }
      return output;
    },
    [getOptionLabel, getLimitTagsText, maxSelectedItemsToShow, maxSelectedItemsToShowOnFocus]
  );
  const renderSummary = componentProps.inputMode === "summary" ? componentProps.renderSummary : defaultRenderTags;
  const renderTags = useCallback(
    (selectedOptions, getTagProps, ownerState) => {
      const summary = renderSummary(selectedOptions, getTagProps, ownerState);
      return typeof summary === "string" ? /* @__PURE__ */ jsx(Typography, { m: 0.5, "data-testid": "multiselect-summary", children: summary }) : summary;
    },
    [renderSummary]
  );
  return renderTags;
}
export {
  useRenderTags
};
//# sourceMappingURL=useRenderTags.js.map
